import { useMemo, useState } from 'react';
import type { Epic } from '../../../api/tasks-client/task-client.type';
import type { Initiative } from '../../../api/initiative-client/initiative-client.type';
import type { Outcome } from '../../../api/strategy-client/strategy-client.type';

/**
 * Hook to search and filter epics
 */
export function useEpicsSearch(epics: Epic[]) {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredEpics = useMemo(() => {
    if (!searchTerm) {
      return epics;
    }

    const lowerSearchTerm = searchTerm.toLowerCase();
    return epics.filter(
      (epic) => epic.name.toLowerCase().includes(lowerSearchTerm) || epic.title.toLowerCase().includes(lowerSearchTerm),
    );
  }, [epics, searchTerm]);

  const handleSearchChange = (value: string) => {
    setSearchTerm(value);
  };

  return { filteredEpics, handleSearchChange };
}

/**
 * Hook to search and filter initiatives
 */
export function useInitiativesSearch(initiatives: Initiative[]) {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredInitiatives = useMemo(() => {
    if (!searchTerm) {
      return initiatives;
    }

    const lowerSearchTerm = searchTerm.toLowerCase();
    return initiatives.filter((initiative) => initiative.name.toLowerCase().includes(lowerSearchTerm));
  }, [initiatives, searchTerm]);

  const handleSearchChange = (value: string) => {
    setSearchTerm(value);
  };

  return { filteredInitiatives, handleSearchChange };
}

/**
 * Hook to search and filter outcomes
 */
export function useOutcomesSearch(outcomes: Outcome[]) {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredOutcomes = useMemo(() => {
    if (!searchTerm) {
      return outcomes;
    }

    const lowerSearchTerm = searchTerm.toLowerCase();
    return outcomes.filter((outcome) => outcome.name.toLowerCase().includes(lowerSearchTerm));
  }, [outcomes, searchTerm]);

  const handleSearchChange = (value: string) => {
    setSearchTerm(value);
  };

  return { filteredOutcomes, handleSearchChange };
}
